
// Mock data for sector performance over time
export interface SectorData {
  date: string;
  sectors: {
    name: string;
    change: number;
  }[];
}

// Generate sample data for the last 30 days
const generateMockData = (): SectorData[] => {
  const sectors = [
    "Technology",
    "Financials", 
    "Healthcare",
    "Consumer Discretionary",
    "Consumer Staples",
    "Industrials", 
    "Communication Services",
    "Energy",
    "Materials", 
    "Utilities",
    "Real Estate"
  ];
  
  const today = new Date();
  const data: SectorData[] = [];
  
  // Generate data for each day (last 30 days)
  for (let i = 30; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(today.getDate() - i);
    
    const dateString = date.toISOString().split('T')[0];
    
    // Generate random changes for each sector
    const sectorChanges = sectors.map(name => {
      // Create some trend in the data
      const baseChange = (Math.random() * 8) - 4; // Range from -4% to +4%
      const trendFactor = i < 15 ? 0.5 : -0.8; // Positive trend early, negative later
      let change = baseChange + (trendFactor * (Math.random() * 1.5));
      
      // Make certain sectors consistently perform better/worse
      if (name === "Technology") change += 1.2; // Tech tends to perform better
      if (name === "Utilities") change -= 0.8; // Utilities tend to perform worse
      
      // Round to 2 decimal places
      change = Math.round(change * 100) / 100;
      
      return { name, change };
    });
    
    data.push({
      date: dateString,
      sectors: sectorChanges
    });
  }
  
  return data;
};

export const sectorHistoricalData = generateMockData();
